import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=6165c381&"
import script from "./OrgChart.vue?vue&type=script&lang=js&"
export * from "./OrgChart.vue?vue&type=script&lang=js&"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=6165c381&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports